import { Client } from '../../client';
import { TokenRepository } from '../../repositories/tokenRepository';
import type { AuthorizationData } from '../../repositories/authRepository';
import { Token } from '../../../entities';
import { TokenResponse } from '../../../responses/responseTypes';
import { secretManager } from '../../../config';
import { handleErrors } from '../../../helpers';

export default class TokenRepositoryImpl implements TokenRepository {
  client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  getToken(data: AuthorizationData): Promise<Token> {
    return this.tokenRequestWith(data);
  }

  getTokenFromRegistration(
    email: string,
    password: string,
    cloudflareToken: string
  ): Promise<Token> {
    const { client } = this;
    return new Promise((resolve, reject) => {
      client
        .post<TokenResponse>('/users', {
          email,
          password,
          cf_token: cloudflareToken,
        })
        .then((response) => {
          const token = new Token(response.data);
          resolve(token);
        })
        .catch((err) => {
          const error = handleErrors(err);
          reject(error);
        });
    });
  }

  async tokenRequestWith(data: AuthorizationData): Promise<Token> {
    const { client } = this;
    const requestData = { ...data, client_id: secretManager.clientID };
    return new Promise((resolve, reject) => {
      client
        .post<TokenResponse>('/oauth/v2/token', requestData)
        .then((response) => {
          const token = new Token(response.data);
          resolve(token);
        })
        .catch((err) => {
          const error = handleErrors(err);
          reject(error);
        });
    });
  }
}
